import { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { useNavigate, useParams } from "react-router";

import { Grid, List, ListItem, ListItemText, Typography, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, TextField, InputLabel, Select, MenuItem, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Card, CardContent, CardHeader, Divider, Box } from '@mui/material';

import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

import moment from 'moment';
import "moment/locale/es-mx";

import { RootState } from '../../../store';
import { openSnackbar } from '../../../store/slices/SnackbarSlice';

import { DialogActionsStyle, DialogContentStyle } from '../../../styles/DialogStyle';

import { InfoField } from '../../../components/InfoField';

import { ActualizarEstatusAudiencia, GuardarInformacion } from '../../../connections/audiencias/AudienciaConnection';
import { SolicitarFechaAudiencia } from '../../../connections/audiencias/AgendaConnection';
import { ObtenerSecretarioMecanografo } from '../../../connections/admin/UsuarioConnection';
import { ObtenerTipoConvenio } from '../../../connections/catalogos/TipoConvenioConnection';
import { ObtenerTipoAudiencias } from '../../../connections/catalogos/TipoAudienciaConnection';
import { ObtenerTipoNoCelebracion } from '../../../connections/catalogos/TipoNoCelebracionConnection';
import { ObtenerTipoCausaDiferimientos } from '../../../connections/catalogos/TipoCausaDiferimientoConnection';

import { UsuarioMecanografoProps } from '../../../interfaces/admin/UsuarioInterface';
import { TipoConvenioProps } from '../../../interfaces/catalogos/TipoConvenioInterface';
import { TipoAudienciaProps } from '../../../interfaces/catalogos/TipoAudienciaInterface';
import { TipoNoCelebracionProps } from '../../../interfaces/catalogos/TipoNoCelebracionInterface';
import { TipoCausaDiferimientoProps } from '../../../interfaces/catalogos/TipoCausaDiferimientoInterface';
import { defaultFechaAudiencia, FechaAudienciaProps } from '../../../interfaces/audiencias/AgendaInterface';
import { GuardarInformacionParams, AudienciaProps } from '../../../interfaces/audiencias/AudienciaInterface';

interface Props {
    audiencia:              AudienciaProps;
    edit?:                  boolean;
    callbackFinalizar?:     ( usuarioAsignado: string ) => Promise<void>
}

export const InformacionAudiencia = ({ audiencia, edit = true, callbackFinalizar }: Props) => {

    const { Id } = useParams();

    const { idUnidad } = useSelector( ( state: RootState ) => state.auth );

    const navigate = useNavigate();

    const dispatch = useDispatch();

    const [loadingFinalizar, setLoadingFinalizar] = useState( false );
    const [loadingGuardar, setLoadingGuardar] = useState( false );

    const [openConfirmacion, setOpenConfirmacion] = useState( false );

    const [celebroAudiencia, setCelebroAudiencia] = useState( true );
    const [fechaInicio, setFechaInicio] = useState( new Date() );

    const [convenio, setConvenio] = useState( false );
    const [tipoConvenio, setTipoConvenio] = useState( 0 );
    const [tipoConvenioArray, setTipoConvenioArray] = useState<TipoConvenioProps[]>( [] );

    const [seDifiere, setSeDifiere] = useState( false );
    const [tipoDiferimiento, setTipoDiferimiento] = useState( 0 );
    const [motivoDefirimiento, setMotivoDefirimiento] = useState( '' );
    const [tipoDiferimientoArray, setTipoDiferimientoArray] = useState<TipoCausaDiferimientoProps[]>( [] );

    const [tipoNoCelebracion, setTipoNoCelebracion] = useState( 0 );
    const [tipoNoCelebracionArray, setTipoNoCelebracionArray] = useState<TipoNoCelebracionProps[]>( [] );

    const [mecanografo, setMecanografo] = useState( 0 );
    const [mecanografoTemp, setMecanografoTemp] = useState( 0 );
    const [mecanografoArray, setMecanografoArray] = useState<UsuarioMecanografoProps[]>( [] );

    const [citaSentencia, setCitaSentencia] = useState( false );

    const [openDialogConfirmacionFinalizar, setOpenDialogConfirmacionFinalizar] = useState( false );
    const [openDialogSolicitarFechaAudiencia, setOpenDialogSolicitarFechaAudiencia] = useState( false );
    const [loadingSolicitarFechaAudiencia, setLoadingSolicitarFechaAudiencia] = useState( false );
    const [solicitarFechaAudiencia, setSolicitarFechaAudiencia] = useState( false );
    const [fechaAudiencia, setFechaAudiencia] = useState<FechaAudienciaProps>( defaultFechaAudiencia );

    const [tipoAudiencia, setTipoAudiencia] = useState( 0 );
    const [tipoAudienciaTemp, setTipoAudienciaTemp] = useState( 0 );
    const [tipoAudienciaArray, setTipoAudienciaArray] = useState<TipoAudienciaProps[]>( [] );
    const [duracionAudiencia, setDuracionAudiencia] = useState( 0 );
    const [agregarDuracion, setAgregarDuracion] = useState( false );

    const validateFields = () => {

        let valid = true;

        if ( !celebroAudiencia && tipoNoCelebracion === 0 ) {

            dispatch( openSnackbar({ message: 'Debes seleccionar el tipo de no celebración', variant: 'warning' }));
            valid = false;

        }

        if ( seDifiere && tipoDiferimiento === 0 ) {

            dispatch( openSnackbar({ message: 'Debes seleccionar el tipo de diferimiento', variant: 'warning' }));
            valid = false;

        }

        if ( seDifiere && tipoDiferimiento === 4 && motivoDefirimiento === '' ) {

            dispatch( openSnackbar({ message: 'Debes escribir el motivo de defirimiento', variant: 'warning' }));
            valid = false;

        }

        if ( convenio && tipoConvenio === 0 ) {

            dispatch( openSnackbar({ message: 'Debes seleccionar el tipo de convenio', variant: 'warning' }));
            valid = false;

        }

        if ( solicitarFechaAudiencia && tipoAudiencia === 0 ) {

            dispatch( openSnackbar({ message: 'Debes seleccionar el tipo de audiencia', variant: 'warning' }));
            valid = false;

        }

        if ( solicitarFechaAudiencia && tipoAudiencia !== 0 && fechaAudiencia.idTipoAudiencia === 0 ) {

            dispatch( openSnackbar({ message: 'Debes solicitar una fecha de audiencia', variant: 'warning' }));
            valid = false;

        }

        if ( mecanografo === 0 ) {

            dispatch( openSnackbar({ message: 'Debes seleccionar un usuario para elaborar el acta de audiencia', variant: 'warning' }));
            valid = false;

        }

        return valid;
    }

    const Guardar = async () => {

        const params: GuardarInformacionParams = {
            idAudiencia: Id ?? '',

            seCelebro: celebroAudiencia,
            idTipoNoCelebracion: tipoNoCelebracion,

            seDifiere: seDifiere,
            idTipoDiferimiento: tipoDiferimiento,
            motivoDiferimiento: motivoDefirimiento,

            convenio: convenio,
            idTipoConvenio: tipoConvenio,

            citaSentencia,
            fechaInicio: celebroAudiencia ? moment( fechaInicio ).format( 'YYYY-MM-DDTHH:mm' ) : '',

            idUsuarioElaboro: mecanografo,
            solicitarFechaAudiencia,
        }

        return await GuardarInformacion(params)
    }

    const handleGuardar = async () => {

        const validate = validateFields();

        if ( !validate ) return;

        setLoadingGuardar( true );

        await Guardar().then(resp => {

            setTimeout(() => {

                const { success, message } = resp;

                if ( success ) {

                    dispatch( openSnackbar({ message: message, variant: 'success' }) );
                    setLoadingGuardar( false );

                }
                else {

                    dispatch( openSnackbar({ message: message, variant: 'error' }) );
                    setLoadingGuardar( false );

                }

            }, 700);

        });

    }

    const handleFinalizar = async () => {

        const validate = validateFields();

        if ( !validate ) return;

        setLoadingFinalizar( true );

        const { success: successGuardar, message: messageGuardar } = await Guardar();

        if (!successGuardar) {

            setTimeout(() => {

                dispatch( openSnackbar({ message: messageGuardar, variant: 'error' }) );
                setLoadingFinalizar( false );

            }, 700);

            return;
        }

        await ActualizarEstatusAudiencia({ idAudiencia: Id ?? '', idEstatus: 31 }).then(resp => {

            const { success, message, asignadoMismoUsuario, usuarioAsignado } = resp;

            if ( success ) {

                setTimeout(() => {

                    if ( asignadoMismoUsuario ) {

                        navigate(`/gestionar-audiencia/elaborar-acta/${ Id ?? '' }`);

                    }
                    else {

                        callbackFinalizar?.( usuarioAsignado );

                    }

                    setLoadingFinalizar(false);

                }, 700);

            }
            else {

                setTimeout(() => {

                    dispatch( openSnackbar({ message: message, variant: 'error' }) );
                    setLoadingFinalizar(false);

                }, 700);

            }

        });

    }

    const handleSolicitarFechaAudiencia = async () => {

        setLoadingSolicitarFechaAudiencia( true );

        await SolicitarFechaAudiencia({ idAudiencia: audiencia.idAudiencia, idAcuerdo: 0, idSubTipoAcuerdo: 0, idTipoAcuerdo: 0, idTipoAudiencia: tipoAudiencia, duracion: agregarDuracion ? duracionAudiencia : 0, }).then((resp) => {

            const { success, message } = resp

            const tipoAudienciaDescripcion = tipoAudienciaArray.find( ({ idTipoAudiencia }) => idTipoAudiencia === tipoAudiencia )?.descripcion ?? '';

            setTimeout(() => {

                if ( success ) {

                    setSolicitarFechaAudiencia( true );

                    setFechaAudiencia({
                        ...resp,
                        idTipoAudiencia: tipoAudiencia,
                        tipoAudiencia: tipoAudienciaDescripcion,
                        duracion: agregarDuracion ? duracionAudiencia : 0,
                    });

                    setLoadingSolicitarFechaAudiencia( false );
                    setOpenDialogSolicitarFechaAudiencia( false );

                }
                else {

                    dispatch( openSnackbar({ message: message, variant: 'success' }) );
                    setLoadingSolicitarFechaAudiencia( false );

                }

            }, 700);

        })

    }

    const handleCelebroAudiencia = ( value: boolean ) => {

        setTipoNoCelebracion( 0 );

        setSeDifiere( false );
        setTipoDiferimiento( 0 );
        setMotivoDefirimiento( '' );

        setConvenio( false );
        setTipoConvenio( 0 );

        setCelebroAudiencia( value );

    }

    const handleChangeDifiere = ( value: boolean ) => {

        setConvenio( false );
        setTipoConvenio( 0 );

        setCitaSentencia( false );

        if ( !value ) {

            setTipoDiferimiento( 0 );
            setMotivoDefirimiento( '' );

        }

        setTipoAudiencia( 0 );
        setSeDifiere( value );

    }

    const handleTipoNoCelebracion = ( value: number ) => {

        if ( value === 1 ) {
            setConvenio( true );
        }
        else if ( value === 3 ) {
            setSeDifiere( true );
        }
        else{
            setConvenio( false );
            setTipoConvenio( 0 );
            setSeDifiere( false );
        }

        setTipoNoCelebracion( value );
    }

    const handleChangeConvenio = ( value: boolean ) => {

        setCitaSentencia( false );

        setTipoAudiencia( 0 );
        setSolicitarFechaAudiencia( false );

        setConvenio( value );

    }

    useEffect(() => {

        async function Obtener() {

            await ObtenerTipoCausaDiferimientos().then( resp => {
                setTipoDiferimientoArray( resp );
            });

        }

        Obtener();

    }, [])

    useEffect(() => {

        async function Obtener() {

            await ObtenerTipoConvenio().then( resp => {
                setTipoConvenioArray( resp );
            });

        }

        Obtener();

    }, [])

    useEffect(() => {

        async function Obtener() {

            await ObtenerTipoNoCelebracion().then( resp => {
                setTipoNoCelebracionArray( resp );
            });

        }

        Obtener();

    }, [])

    useEffect(() => {

        async function Obtener() {

            await ObtenerSecretarioMecanografo().then( resp => {
                setMecanografoArray( resp );
            });

        }

        Obtener();

    }, [])

    useEffect(() => {

        async function Obtener() {

            await ObtenerTipoAudiencias().then( resp => {
                setTipoAudienciaArray( resp );
            });

        }

        Obtener();

    }, [])

    useEffect(() => {

        if ( audiencia.idAudiencia !== 0 ) {

            const {
                seCelebro, generarConvenio, idTipoConvenio, motivoDiferimiento, seDifiere, idTipoCausaDiferimiento, idTipoNoCelebracion,
                citaSentencia, fechaHoraInicio, solicitarFechaAudiencia, fechaAudiencia, idUsuarioElaboro,
            } = audiencia;

            setCelebroAudiencia( seCelebro );
            setConvenio( generarConvenio );
            setTipoConvenio( idTipoConvenio );
            setMotivoDefirimiento( motivoDiferimiento );
            setSeDifiere( seDifiere );
            setTipoDiferimiento( idTipoCausaDiferimiento );
            setTipoNoCelebracion( idTipoNoCelebracion );

            setSolicitarFechaAudiencia( solicitarFechaAudiencia );
            setFechaAudiencia( fechaAudiencia )
            setTipoAudienciaTemp( fechaAudiencia.idTipoAudiencia ?? 0 );
            setDuracionAudiencia( fechaAudiencia.duracion )

            setCitaSentencia( citaSentencia )
            setFechaInicio( fechaHoraInicio ?? new Date() );

            setMecanografoTemp( idUsuarioElaboro );

        }

    }, [ audiencia ])

    useEffect(() => {

        if ( tipoAudienciaTemp !== 0 && tipoAudienciaArray.length !== 0 ) {
            setTipoAudiencia( tipoAudienciaTemp );
        }

    }, [ tipoAudienciaTemp, tipoAudienciaArray ])

    useEffect(() => {

        if ( mecanografoTemp !== 0 && mecanografoArray.length !== 0 ) {
            setMecanografo( mecanografoTemp );
        }

    }, [ mecanografoTemp, mecanografoArray ])

    return (
        <>

            <Grid container spacing={ 3 } mt={ 3 }>

                <Grid size={{ md: 4, xs: 12 }}>

                    <List disablePadding>

                        <ListItem sx={{ py: 0, px: 0 }}>

                            <ListItemText
                                sx={{ mr: 2 }}
                                primary={<Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Tipo de audiencia: </Typography>}
                                secondary={ <Typography variant='subtitle2' fontWeight={ 'bold' }> { audiencia.tipoAudiencia } </Typography> }
                            />

                        </ListItem>

                    </List>

                </Grid>

                <Grid size={{ md: 4, xs: 12 }}>

                    <List disablePadding>

                        <ListItem sx={{ py: 0, px: 0 }}>

                            <ListItemText
                                sx={{ mr: 2 }}
                                primary={<Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Fecha programada: </Typography>}
                                secondary={
                                    <Typography variant='subtitle2' fontWeight={ 'bold' }>

                                        {
                                            audiencia.fechaInicioAgenda
                                            &&
                                                <>
                                                    <span>{ moment( audiencia.fechaInicioAgenda ).format('DD-MM-YYYY') }</span>

                                                    <span style={{ margin: '0 2px' }}> </span>

                                                    <span>{ moment( audiencia.fechaInicioAgenda ).format('HH:mm') }</span>

                                                    <span style={{ margin: '0 2px' }}>-</span>

                                                    <span>{ audiencia.fechaFinAgenda ? moment( audiencia.fechaFinAgenda ).format('HH:mm') : '' }</span>
                                                </>
                                        }

                                    </Typography>
                                }
                            />

                        </ListItem>

                    </List>

                </Grid>

                <Grid size={{ md: 4, xs: 12 }}>

                    <List disablePadding>

                        <ListItem sx={{ py: 0, px: 0 }}>

                            <ListItemText
                                sx={{ mr: 2 }}
                                primary={<Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Secretario(a) de audiencia: </Typography>}
                                secondary={ <Typography variant='subtitle2' fontWeight={ 'bold' }> { audiencia.secretario } </Typography> }
                            />

                        </ListItem>

                    </List>

                </Grid>

                <Grid size={{ md: 4, xs: 12 }}>

                    {
                        edit
                        ?
                            <FormControl disabled={ !edit || ( solicitarFechaAudiencia && fechaAudiencia.idSecretario !== 0 ) }>

                                <FormLabel>¿Se celebró la audiencia?</FormLabel>

                                <RadioGroup row>

                                    <FormControlLabel value="si" control={ <Radio checked={ celebroAudiencia } onChange={ () => handleCelebroAudiencia( true ) } /> } label="Si" />
                                    <FormControlLabel value="no" control={ <Radio checked={ !celebroAudiencia } onChange={ () => handleCelebroAudiencia( false ) } /> } label="No" />

                                </RadioGroup>

                            </FormControl>
                        :
                            <List disablePadding>

                                <ListItem sx={{ py: 0, px: 0 }}>

                                    <ListItemText
                                        sx={{ mr: 2 }}
                                        primary={<Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> ¿Se celebró la audiencia? </Typography>}
                                        secondary={ <Typography variant='subtitle2' fontWeight={ 'bold' }> { celebroAudiencia ? 'Si' : 'No' } </Typography> }
                                    />

                                </ListItem>

                            </List>
                    }

                </Grid>

                {
                    celebroAudiencia
                    ?
                        <Grid size={{ md: 8, xs: 12 }}>

                            {
                                edit
                                ?

                                        <LocalizationProvider dateAdapter={ AdapterMoment }>

                                            <DateTimePicker
                                                label="Fecha de inicio de la audiencia"
                                                sx={{ width: '100%' }}
                                                value={ moment( fechaInicio ) }
                                                onChange={ (e) => setFechaInicio( new Date( e?.toLocaleString() ?? new Date() ) ) }
                                                maxDate={ moment( new Date() ) }
                                                disabled={ !edit }
                                            />

                                        </LocalizationProvider>

                                :
                                    <List disablePadding>

                                        <ListItem sx={{ py: 0, px: 0 }}>

                                            <ListItemText
                                                sx={{ mr: 2 }}
                                                primary={<Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Fecha de inicio de la audiencia: </Typography>}
                                                secondary={ <Typography variant='subtitle2' fontWeight={ 'bold' }> { fechaInicio ? moment( fechaInicio ).format( 'DD-MM-YYYY HH:mm' ) : '' } </Typography> }
                                            />

                                        </ListItem>

                                    </List>
                            }

                        </Grid>
                    :
                        null
                }

                {
                    !celebroAudiencia
                    ?
                        <Grid size={{ md: 8, xs: 12 }}>

                            {
                                edit
                                ?
                                    <FormControl fullWidth disabled={ !edit || ( solicitarFechaAudiencia && fechaAudiencia.idSecretario !== 0 ) }>

                                        <InputLabel>Tipo de no celebración</InputLabel>

                                        <Select
                                            label="Tipo de no celebración"
                                            value={ tipoNoCelebracion }
                                            onChange={ (e) => handleTipoNoCelebracion( e.target.value ) }
                                        >
                                            <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                tipoNoCelebracionArray
                                                .map( ({ idTipoNoCelebracion, descripcion }) => (
                                                    <MenuItem key={ idTipoNoCelebracion } value={ idTipoNoCelebracion }>{ descripcion }</MenuItem>
                                                ))
                                            }
                                        </Select>

                                    </FormControl>
                                :
                                    <List disablePadding>

                                        <ListItem sx={{ py: 0, px: 0 }}>

                                            <ListItemText
                                                sx={{ mr: 2 }}
                                                primary={<Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Tipo de no celebración: </Typography>}
                                                secondary={ <Typography variant='subtitle2' fontWeight={ 'bold' }> { tipoAudienciaArray.find( ({ idTipoAudiencia }) => idTipoAudiencia === tipoAudiencia )?.descripcion } </Typography> }
                                            />

                                        </ListItem>

                                    </List>
                            }

                        </Grid>
                    :
                        null
                }

                <Grid size={{ md: 4, xs: 12 }}>

                    {
                        edit
                        ?
                            <FormControl disabled={ !edit || ( solicitarFechaAudiencia && fechaAudiencia.idSecretario !== 0 ) }>

                                <FormLabel>¿Se difieré la audiencia?</FormLabel>

                                <RadioGroup row>

                                    <FormControlLabel value="si" control={ <Radio checked={ seDifiere } onChange={ () => handleChangeDifiere( true ) } />} label="Si" />
                                    <FormControlLabel value="no" control={ <Radio checked={ !seDifiere } onChange={ () => handleChangeDifiere( false ) } />} label="No" />

                                </RadioGroup>

                            </FormControl>
                        :
                            <List disablePadding>

                                <ListItem sx={{ py: 0, px: 0 }}>

                                    <ListItemText
                                        sx={{ mr: 2 }}
                                        primary={<Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> ¿Se difieré la audiencia? </Typography>}
                                        secondary={ <Typography variant='subtitle2' fontWeight={ 'bold' }> { seDifiere ? 'Si' : 'No' } </Typography> }
                                    />

                                </ListItem>

                            </List>
                    }

                </Grid>

                <Grid size={{ md: 8, xs: 12 }}>

                    {
                        seDifiere
                        ?
                            edit
                            ?
                                <FormControl fullWidth disabled={ !edit || ( solicitarFechaAudiencia && fechaAudiencia.idSecretario !== 0 ) }>

                                    <InputLabel>Tipo de diferimiento</InputLabel>
                                    <Select
                                        label="Tipo de diferimiento"
                                        value={ tipoDiferimiento }
                                        onChange={ (e) => { setTipoDiferimiento( e.target.value ); setTipoAudiencia( 0 ); }}
                                    >

                                        <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                        {
                                            tipoDiferimientoArray
                                            .map( ({ idTipoCausaDiferimiento, descripcion }) => (
                                                <MenuItem key={ idTipoCausaDiferimiento } value={ idTipoCausaDiferimiento }>{ descripcion }</MenuItem>
                                            ))
                                        }
                                    </Select>

                                </FormControl>
                            :
                                <List disablePadding>

                                    <ListItem sx={{ py: 0, px: 0 }}>

                                        <ListItemText
                                            sx={{ mr: 2 }}
                                            primary={<Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Tipo de diferimiento: </Typography>}
                                            secondary={ <Typography variant='subtitle2' fontWeight={ 'bold' }> { tipoDiferimientoArray.find( ({ idTipoCausaDiferimiento }) => idTipoCausaDiferimiento === tipoDiferimiento )?.descripcion } </Typography> }
                                        />

                                    </ListItem>

                                </List>
                        :
                        null
                    }

                </Grid>

                {
                    ( seDifiere && tipoDiferimiento === 4 )
                    &&
                        <Grid size={{ md: 12, xs: 12 }}>

                            {
                                edit
                                ?
                                    <FormControl fullWidth>

                                        <TextField
                                            label="Motivo"
                                            multiline
                                            rows={ 4 }
                                            fullWidth
                                            name="motivoDiferimiento"
                                            variant="outlined"
                                            value={ motivoDefirimiento }
                                            onChange={ (e) => setMotivoDefirimiento( e.target.value ) }
                                            disabled={ !edit || ( solicitarFechaAudiencia && fechaAudiencia.idSecretario !== 0 ) }
                                        />

                                    </FormControl>
                                :
                                    <List disablePadding>

                                        <ListItem sx={{ py: 0, px: 0 }}>

                                            <ListItemText
                                                sx={{ mr: 2 }}
                                                primary={<Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Motivo: </Typography>}
                                                secondary={ <Typography variant='subtitle2' fontWeight={ 'bold' }> { motivoDefirimiento } </Typography> }
                                                />

                                        </ListItem>

                                    </List>
                            }

                        </Grid>
                }

                <Grid size={{ md: 4, xs: 12 }}>

                    {
                        edit
                        ?
                            <FormControl disabled={ !edit || seDifiere || tipoNoCelebracion !== 0 || ( solicitarFechaAudiencia && fechaAudiencia.idSecretario !== 0 ) }>

                                <FormLabel>¿Se llego a un convenio?</FormLabel>
                                <RadioGroup row>

                                    <FormControlLabel value="si" control={ <Radio checked={ convenio } onChange={ () => handleChangeConvenio( true ) } />} label="Si" />
                                    <FormControlLabel value="no" control={ <Radio checked={ !convenio } onChange={ () => handleChangeConvenio( false ) } />} label="No" />

                                </RadioGroup>

                            </FormControl>
                        :
                            <List disablePadding>

                                <ListItem sx={{ py: 0, px: 0 }}>

                                    <ListItemText
                                        sx={{ mr: 2 }}
                                        primary={<Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> ¿Se llego a un convenio? </Typography>}
                                        secondary={ <Typography variant='subtitle2' fontWeight={ 'bold' }> { convenio ? 'Si' : 'No' } </Typography> }
                                        />

                                </ListItem>

                            </List>
                    }

                </Grid>

                {
                    convenio
                    &&
                        <Grid size={{ md: 8, xs: 12 }}>

                            {
                                edit
                                ?
                                    <FormControl fullWidth disabled={ !edit || ( solicitarFechaAudiencia && fechaAudiencia.idSecretario !== 0 ) }>

                                        <InputLabel>Tipo de convenio</InputLabel>

                                        <Select
                                            label="Tipo de convenio"
                                            value={ tipoConvenio }
                                            onChange={ (e) => setTipoConvenio( e.target.value ) }
                                        >

                                            <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                tipoConvenioArray
                                                .map( ({ idTipoConvenio, descripcion }) => (
                                                    <MenuItem key={ idTipoConvenio } value={ idTipoConvenio }>{ descripcion }</MenuItem>
                                                ))
                                            }
                                        </Select>

                                    </FormControl>
                                :
                                    <List disablePadding>

                                        <ListItem sx={{ py: 0, px: 0 }}>

                                            <ListItemText
                                                sx={{ mr: 2 }}
                                                primary={<Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Motivo: </Typography>}
                                                secondary={ <Typography variant='subtitle2' fontWeight={ 'bold' }> { tipoConvenioArray.find( ({ idTipoConvenio }) => idTipoConvenio === tipoConvenio )?.descripcion } </Typography> }
                                            />

                                        </ListItem>

                                    </List>
                            }

                        </Grid>
                }

                {
                    audiencia.habilitarCitacionSentencia
                    &&
                        <Grid size={{ md: 12, xs: 12 }}>

                            {
                                edit
                                ?
                                    <FormControl disabled={ !edit || seDifiere || convenio || solicitarFechaAudiencia }>

                                        <FormLabel>¿Desea realizar la citación de sentencia?</FormLabel>

                                        <RadioGroup row>

                                            <FormControlLabel value="Si" control={ <Radio checked={ citaSentencia } onChange={ () => { setCitaSentencia( true ); setSolicitarFechaAudiencia( false ); setTipoAudiencia( 0 ); } } /> } label="Si" />
                                            <FormControlLabel value="No" control={ <Radio checked={ !citaSentencia } onChange={ () => setCitaSentencia( false ) } /> } label="No" />

                                        </RadioGroup>

                                    </FormControl>
                                :
                                    <List disablePadding>

                                        <ListItem sx={{ py: 0, px: 0 }}>

                                            <ListItemText
                                                sx={{ mr: 2 }}
                                                primary={<Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> ¿Desea realizar la citación de sentencia? </Typography>}
                                                secondary={ <Typography variant='subtitle2' fontWeight={ 'bold' }> { citaSentencia ? 'Si' : 'No' } </Typography> }
                                            />

                                        </ListItem>

                                    </List>
                            }

                        </Grid>
                }

                <Grid size={{ md: 12, xs: 12 }}>

                    {
                        edit
                        ?
                            <FormControl fullWidth disabled={ !edit || ( solicitarFechaAudiencia && fechaAudiencia.idSecretario !== 0 ) || convenio || citaSentencia }>

                                <FormLabel>¿Desea solicitar fecha de audiencia?</FormLabel>

                                <RadioGroup row >

                                    <FormControlLabel value="Si" control={ <Radio checked={ solicitarFechaAudiencia } onChange={ () => { setSolicitarFechaAudiencia( true ); setCitaSentencia( false ); } } /> } label="Si" />
                                    <FormControlLabel value="No" control={ <Radio checked={ !solicitarFechaAudiencia } onChange={ () => { setSolicitarFechaAudiencia( false ); setTipoAudiencia( 0 ); } } /> } label="No" />

                                </RadioGroup>

                            </FormControl>
                        :
                            <List disablePadding>

                                <ListItem sx={{ py: 0, px: 0 }}>

                                    <ListItemText
                                        sx={{ mr: 2 }}
                                        primary={<Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> ¿Desea solicitar fecha de audiencia? </Typography>}
                                        secondary={ <Typography variant='subtitle2' fontWeight={ 'bold' }> { solicitarFechaAudiencia ? 'Si' : 'No' } </Typography> }
                                    />

                                </ListItem>

                            </List>
                    }

                </Grid>

                {
                    solicitarFechaAudiencia
                    &&
                        <Grid size={{ md: 12, xs: 12 }}>

                            <Card>

                                <CardHeader
                                    sx={{ backgroundColor: (theme) => theme.palette.primary.main }}
                                    subheader={
                                        <Typography sx={{ fontSize: 14, fontWeight: 'bold', color: 'white' }}>
                                            Solicitar fecha de audiencia
                                        </Typography>
                                    }
                                />

                                <Divider />

                                <CardContent>

                                    <Grid container spacing={ 3 } mt={ 1 }>

                                        <Grid size={{ md: ( tipoAudiencia !== 0 && agregarDuracion ) ? 4 : 6, xs: 12 }} textAlign={ edit ? 'start' : 'center' }>

                                            {
                                                edit
                                                ?
                                                    <FormControl fullWidth>

                                                        <InputLabel>Tipo de audiencia</InputLabel>

                                                        <Select
                                                            label="Tipo de audiencia"
                                                            value={ tipoAudiencia }
                                                            onChange={ (e) => {

                                                                const id = e.target.value;

                                                                setTipoAudiencia( id );

                                                                const tipoAudienciaFound = tipoAudienciaArray.find( ({ idTipoAudiencia }) => idTipoAudiencia === id );

                                                                setDuracionAudiencia( tipoAudienciaFound?.duracion ?? 30 );
                                                            }}
                                                            disabled={ solicitarFechaAudiencia && fechaAudiencia.idSecretario !== 0 }
                                                        >

                                                            <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>

                                                            {
                                                                tipoAudienciaArray
                                                                .filter( ta => {

                                                                    if ( seDifiere ) {
                                                                        return ta.idTipoAudiencia === audiencia.idTipoAudiencia;
                                                                    }

                                                                    if ( audiencia.expediente.medioPreparatorio ) {
                                                                        return ta.medioPreparatorio === true;
                                                                    }

                                                                    if ( audiencia.expediente.incidente ) {
                                                                        return ta.idTipoAudiencia === 15;
                                                                    }

                                                                    if ( idUnidad === 3 ) {
                                                                        return ta.idTipoAudiencia === 4;
                                                                    }

                                                                    if ( audiencia.expediente.idTipoJuicio === 1 || audiencia.expediente.idTipoJuicio === 2 ) {
                                                                        return ta.tradicional === true && ta.idTipoAudiencia !== 15;
                                                                    }

                                                                    if ( audiencia.expediente.idTipoJuicio === 3 || audiencia.expediente.idTipoJuicio === 4 ) {
                                                                        return ta.oral === true && ta.idTipoAudiencia !== 15;
                                                                    }

                                                                    return false;
                                                                })
                                                                .map(({ idTipoAudiencia, descripcion }) => (
                                                                    <MenuItem key={ idTipoAudiencia } value={ idTipoAudiencia }>
                                                                        { descripcion }
                                                                    </MenuItem>
                                                                ))
                                                            }

                                                        </Select>

                                                    </FormControl>
                                                :
                                                    <InfoField
                                                        label="Tipo de audiencia"
                                                        value={ audiencia.tipoAudiencia }
                                                    />
                                            }

                                            {
                                                ( tipoAudiencia !== 0 && edit )
                                                &&
                                                    <Box sx={{ mt: 1, display: 'flex', alignItems: 'center', gap: 2 }}>
                                                        <Typography sx={{ fontSize: 14, color: 'text.secondary' }}>¿Desea agregar duración a esta audiencia?</Typography>
                                                        <RadioGroup row>
                                                            <FormControlLabel value="Si" control={ <Radio disabled={ solicitarFechaAudiencia && fechaAudiencia.idSecretario !== 0 } checked={ agregarDuracion } onChange={ () => setAgregarDuracion( true ) } /> } label={ <Typography>Si</Typography> } />
                                                            <FormControlLabel value="No" control={ <Radio disabled={ solicitarFechaAudiencia && fechaAudiencia.idSecretario !== 0 } checked={ !agregarDuracion } onChange={ () => setAgregarDuracion( false ) } /> } label={ <Typography>No</Typography> } />
                                                        </RadioGroup>
                                                    </Box>
                                            }

                                        </Grid>

                                        {
                                            ( tipoAudiencia !== 0 && edit && agregarDuracion )
                                            &&
                                                <Grid size={{ md: 2, xs: 12 }}>

                                                    <TextField
                                                        label='Duración(Minutos)'
                                                        type="number"
                                                        value={ duracionAudiencia }
                                                        slotProps={{ htmlInput: { min: tipoAudienciaArray.find(({ idTipoAudiencia }) => idTipoAudiencia === tipoAudiencia)?.duracion ?? 30 } }}
                                                        disabled={ solicitarFechaAudiencia && fechaAudiencia.idSecretario !== 0 }
                                                        onChange={ (e) => setDuracionAudiencia( Number( e.target.value ) ) }
                                                        onBlur={ (e) => {
                                                            const min = tipoAudienciaArray.find(({ idTipoAudiencia }) => idTipoAudiencia === tipoAudiencia)?.duracion ?? 30;
                                                            if ( Number( e.target.value ) < min ) setDuracionAudiencia( min );
                                                        }}
                                                    />

                                                </Grid>
                                        }

                                        {
                                            edit
                                            &&
                                                <Grid size={{ md: 3, xs: 12 }}>

                                                    <Button
                                                        fullWidth
                                                        variant='contained'
                                                        startIcon={ <CalendarTodayIcon /> }
                                                        onClick={ () => setOpenDialogSolicitarFechaAudiencia( true ) }
                                                        disabled={ tipoAudiencia === 0 || ( solicitarFechaAudiencia && fechaAudiencia.idSecretario !== 0 ) }
                                                    >
                                                        Solicitar fecha de audiencia
                                                    </Button>

                                                </Grid>
                                        }

                                        <Grid size={{ md: edit ? 3 : 6, xs: 12 }}>

                                            {
                                                fechaAudiencia.idSecretario !== 0
                                                &&
                                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, textAlign: 'center' }}>

                                                        <Typography variant="body1" color="text.secondary">
                                                            Fecha de audiencia:
                                                        </Typography>

                                                        <Typography variant="body1" fontWeight="bold">
                                                            { moment( fechaAudiencia.fechaInicio ).format('DD-MM-YYYY') } { moment( fechaAudiencia.fechaInicio ).format('HH:mm') } - { moment( fechaAudiencia.fechaFin ).format('HH:mm') }
                                                        </Typography>

                                                        <Typography variant="body2" color="text.secondary">
                                                            { fechaAudiencia.sala }
                                                        </Typography>

                                                    </Box>
                                            }

                                        </Grid>

                                    </Grid>

                                </CardContent>

                            </Card>

                        </Grid>
                }

                {
                    edit
                    &&
                        <Grid size={{ md: 12, xs: 12 }}>

                            <FormControl fullWidth>

                                <InputLabel>Seleccione el usuario para elaborar el acta de audiencia</InputLabel>

                                <Select
                                    label="Seleccione el usuario para elaborar el acta de audiencia"
                                    value={ mecanografo }
                                    onChange={ (e) => setMecanografo( e.target.value ) }
                                    renderValue={( selected ) => {
                                        if ( selected === 0 ) return 'Selecciona una opción';

                                        const mecanografo = mecanografoArray.find(u => u.idUsuario === selected);

                                        return mecanografo?.usuario ?? '';
                                    }}
                                >

                                    <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                    {
                                        mecanografoArray
                                        .map( ({ idUsuario, usuario, totalAcuerdos, totalAcuerdosPendientes }) => (
                                            <MenuItem key={ idUsuario } value={ idUsuario }>

                                                <Box sx={{ display: 'flex', flexDirection: 'column' }}>

                                                    <Typography variant="body1">{ usuario }</Typography>
                                                    <Typography variant="caption" color="text.secondary">
                                                        Total de actas de audiencia asignadas: <strong>{ totalAcuerdos }</strong> | Actas de audiencia pendientes: <strong>{ totalAcuerdosPendientes }</strong>
                                                    </Typography>

                                                </Box>

                                            </MenuItem>
                                        ))
                                    }

                                </Select>

                            </FormControl>

                        </Grid>
                }

                {
                    edit
                    &&
                        <Grid size={{ md: 12, xs: 12 }} sx={{ mt: 3 }}>

                            <Grid container spacing={ 3 }>

                                <Grid size={{ md: 6, xs: 12 }}>

                                    <Button
                                        fullWidth
                                        color='secondary'
                                        variant="outlined"
                                        loading={ loadingGuardar }
                                        onClick={ handleGuardar }
                                    >
                                        Guardar
                                    </Button>

                                </Grid>

                                <Grid size={{ md: 6, xs: 12 }} style={{ textAlign: 'left' }}>

                                    <Button
                                        fullWidth
                                        color='primary'
                                        variant="contained"
                                        onClick={ () => setOpenConfirmacion( true ) }
                                    >
                                        Finalizar
                                    </Button>

                                </Grid>

                            </Grid>

                        </Grid>
                }

            </Grid>

            <Dialog
                fullWidth
                maxWidth='sm'
                open={ openDialogSolicitarFechaAudiencia }
                onClose={ () => {} }
            >

                <DialogTitle>
                    Confirmación
                </DialogTitle>

                <DialogContent>

                    <DialogContentText>
                        ¿Desea solicitar fecha de <strong>{ tipoAudienciaArray.find( ({ idTipoAudiencia }) => idTipoAudiencia === tipoAudiencia )?.descripcion }</strong>?
                    </DialogContentText>

                </DialogContent>

                <DialogActions>

                    <Button color="secondary" disabled={ loadingSolicitarFechaAudiencia } onClick={ () => { setOpenDialogSolicitarFechaAudiencia( false ); } }> Cancelar </Button>

                    <Button
                        variant='contained'
                        onClick={ handleSolicitarFechaAudiencia }
                        loading={ loadingSolicitarFechaAudiencia }
                    >
                        Aceptar
                    </Button>

                </DialogActions>

            </Dialog>

            <Dialog
                fullWidth
                maxWidth='xs'
                open={ openDialogConfirmacionFinalizar }
                onClose={ () => {} }
            >

                <DialogTitle>
                    Confirmación
                </DialogTitle>

                <DialogContent sx={ DialogContentStyle }>

                    <DialogContentText>
                        ¿Desea finalizar la celebracion de la audiencia?
                    </DialogContentText>

                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>

                    <Button color="secondary" disabled={ loadingFinalizar } onClick={ () => setOpenDialogConfirmacionFinalizar( false ) }> Cancelar </Button>
                    <Button variant='contained' loading={ loadingFinalizar } onClick={ handleFinalizar } > Aceptar </Button>

                </DialogActions>

            </Dialog>

            <Dialog
                maxWidth='sm'
                fullWidth
                open={ openConfirmacion }
                onClose={ () => {} }
            >

                <DialogTitle>
                    Confirmación
                </DialogTitle>

                <DialogContent>

                    <DialogContentText>
                        ¿Desea finalizar la celebración de la audiencia?
                    </DialogContentText>

                </DialogContent>

                <DialogActions>

                    <Button color='secondary' disabled={ loadingFinalizar } onClick={ () => setOpenConfirmacion( false ) }> Cancelar </Button>
                    <Button loading={ loadingFinalizar } onClick={ handleFinalizar } variant='contained' > Aceptar </Button>

                </DialogActions>
            </Dialog>

        </>
    )
}
